import styled, { css } from 'styled-components';

import { DEVICE } from '@hero/constants';

const PageLayout = styled.div`
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  height: calc(100vh - 275px);

  ${({ fullHeight }) =>
    fullHeight &&
    css`
      height: calc(100vh - 40px);
    `}

  ${DEVICE.mobile.max} {
    height: 100%;
  }
`;

const PageLayoutContentInner = styled.div`
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  gap: 16px;
  padding: 0 var(--size-page-padding-xxl);

  ${DEVICE.mobile.max} {
    padding: 0 var(--size-page-padding-sm);
  }
`;

const PageLayoutContent = styled.div`
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  height: 100%;
  overflow-y: overlay;
  padding-top: 16px;

  ${DEVICE.mobile.max} {
    overflow-y: unset;
  }
`;

export { PageLayout, PageLayoutContent, PageLayoutContentInner };
